/*
  Halloween collection page — category card → section smooth scroll.

  Any element with [data-hwp-scroll] whose href is an in-page anchor ("#id")
  scrolls smoothly to that element, offset by the sticky header height
  (--header-height is maintained by main.js). Links to real URLs are left alone.
*/
(function () {
  if (window.hwpScrollInit) return;
  window.hwpScrollInit = true;

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var px = parseInt(raw, 10);
    return (isNaN(px) ? 0 : px) + 16;
  }

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('[data-hwp-scroll]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;

    var target = document.getElementById(href.slice(1));
    if (!target) return;

    evt.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', href);
    }
  });
})();
